import TomSelect from "tom-select";

type SelectElement = HTMLSelectElement & { tomselect?: TomSelect };

const selector = "[data-select]";

const initializeTomSelect = () => {
  document.querySelectorAll<HTMLSelectElement>(selector).forEach((element) => {
    const selectElement = element as SelectElement;
    if (selectElement.tomselect) return;

    const itemLabel = selectElement.dataset.selectItemLabel;
    new TomSelect(
      selectElement,
      itemLabel
        ? {
            maxOptions: null,
            plugins: ["remove_button"],
            render: {
              item: (data, escape) =>
                `<div title="${escape(data.text)}">${escape(data[itemLabel])}</div>`,
            },
          }
        : {},
    );
  });
};

const destroyTomSelect = () => {
  document.querySelectorAll<HTMLSelectElement>(selector).forEach((element) => {
    const selectElement = element as SelectElement;
    selectElement.tomselect?.destroy();
  });
};

document.addEventListener("turbo:load", initializeTomSelect);
document.addEventListener("turbo:render", initializeTomSelect);
document.addEventListener("turbo:before-cache", destroyTomSelect);
